const $attention = document.querySelector('.js-c-Attention');
const $close = document.querySelector('.js-c-Attention__close');
const $footer = document.querySelector('.js-c-Footer');

function modal_close() {
  sessionStorage.setItem('modal', 'hide');
  $attention.classList.remove('is-show');
  $footer.classList.remove('is-modal');
}

function modal_open() {
  $attention.classList.add('is-show');
  $footer.classList.add('is-modal');
}

if( $attention || $close ) {

  if(sessionStorage.getItem('modal', 'hide')) {
    modal_close();

  } else {
    setTimeout(function(){
      modal_open();
    }, 1000);
  }

  $close.addEventListener('click', modal_close, false);
}
